module.exports = __webpack_public_path__ + "img/logo.a73417a2.svg";